import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'e42097e0-7bcf-434a-8647-4b06ea43e6d4',
    countryCodes: ['BE'],
    locale: 'fr-BE',
    languages: [
        {
            countryCode: 'NL',
            url: 'https://www.zalando-lounge.be',
            active: false,
        },
        {
            countryCode: 'FR',
            url: 'https://fr.zalando-lounge.be',
            active: true,
        },
    ],
});
